var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0767 12.2425V11.0766C11.0767 10.4581 10.8311 9.86498 10.3937 9.42766C9.95641 8.99034 9.36328 8.74466 8.74482 8.74466H5.24695C4.62849 8.74466 4.03536 8.99034 3.59804 9.42766C3.16072 9.86498 2.91504 10.4581 2.91504 11.0766V12.2425",
    stroke: "#155DFC",
    strokeWidth: 1.16596,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99598 6.41276C8.28386 6.41276 9.32789 5.36872 9.32789 4.08084C9.32789 2.79296 8.28386 1.74893 6.99598 1.74893C5.7081 1.74893 4.66406 2.79296 4.66406 4.08084C4.66406 5.36872 5.7081 6.41276 6.99598 6.41276Z",
    stroke: "#155DFC",
    strokeWidth: 1.16596,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16);
export default __webpack_public_path__ + "static/media/icon16.8a17b3cbb673acd96bc927acf5d0b3af.svg";
export { ForwardRef as ReactComponent };